import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useAuthStore } from '@/modules/user/stores';

const useClockInQuery = () => {
  const { contactId } = useAuthStore();
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (clockIn: boolean) =>
      api.put(API_URL.CONTACTS_CLOCK_IN_BY_CONTACT_ID(contactId), undefined, {
        params: {
          clockIn: clockIn,
        },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.CONTACTS_BY_CONTACT_ID(contactId)],
        });
      },
    }
  );

  return mutateAsync;
};

export default useClockInQuery;
